import { Box, Button, type ButtonProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { NavLinkProps } from "react-router";

export const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: 0,
  paddingRight: 0,
  width: "100%",
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
}));

export const NavScroller = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flex: "1 1 0",
  minWidth: 0,
  [theme.breakpoints.down("sm")]: {
    flex: "1 1 100%",
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  flex: 1,
  gap: theme.spacing(0.5),
  width: "max-content",
  minWidth: "100%",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(0.25),
    justifyContent: "flex-start",
  },
}));

export const PillWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  flex: "0 0 auto",
});

export const PillButton = styled(Button)<
  ButtonProps & Partial<NavLinkProps> & { $isActive: boolean; $color?: string }
>(({ theme, $isActive, $color }) => ({
  minWidth: "auto",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  textTransform: "none",
  borderRadius: $isActive ? 0 : theme.spacing(1.5),
  borderBottom: $isActive
    ? `0.125rem solid ${$color ?? theme.palette.text.primary}`
    : "none",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  textDecoration: "none",
  color: "inherit",
  flex: "0 0 auto",

  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "none",
  },
}));

export const PillText = styled(Typography)<{
  $isActive: boolean;
  $color?: string;
}>(({ theme, $isActive, $color }) => ({
  textWrap: "nowrap",
  fontWeight: $isActive ? 700 : 500,
  color: $isActive
    ? ($color ?? theme.palette.text.primary)
    : theme.palette.text.secondary,
}));

